import { render, staticRenderFns } from "./ArchivadoDeclinado.vue?vue&type=template&id=f75f3bbe&"
import script from "./ArchivadoDeclinado.vue?vue&type=script&lang=js&"
export * from "./ArchivadoDeclinado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports